import React, {Component} from 'react';
import CustomForm from "../../../shared/components/form/CustomForm";
import {dailyPatrolLogFieldConfig} from "../../../shared/components/form/DailyPatrolLogFieldConfig";

class DailyPatrolLogFieldCard extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  render() {
    return (
      <CustomForm
        config={dailyPatrolLogFieldConfig}
        onSubmit={(form) => this.props.onSave(form)}
        isLoading={this.props.isLoading}
        initialValues={this.props.initialValues}
      />
    )
  }

}

export default DailyPatrolLogFieldCard;
